module.exports = __webpack_public_path__ + "img/quiz-index.e7f8574.jpeg";